import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import S from "../../store";

import Form from "../common/Form";

function LanguageSelector({ customStyle = "" }) {
  const { i18n } = useTranslation();
  const [selectedLang, setSelectedLang] = useState(i18n.language);

  useEffect(() => {
    const userPreferedLang = S.store.getState().auth.user.language;
    i18n.changeLanguage(userPreferedLang);
    setSelectedLang(userPreferedLang);
  }, [i18n]);

  const handleChange = (e) => {
    i18n.changeLanguage(e.target.value);
    setSelectedLang(e.target.value);
  };

  return (
    <div className={`hidden md:flex items-center ${customStyle}`}>
      <div className={"logo mb-1 mr-2"}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 10C19 12.3869 18.0518 14.6761 16.364 16.364C14.6761 18.0518 12.3869 19 10 19M19 10C19 7.61305 18.0518 5.32387 16.364 3.63604C14.6761 1.94821 12.3869 1 10 1M19 10H1M10 19C7.61305 19 5.32387 18.0518 3.63604 16.364C1.94821 14.6761 1 12.3869 1 10M10 19C11.657 19 13 14.97 13 10C13 5.03 11.657 1 10 1M10 19C8.343 19 7 14.97 7 10C7 5.03 8.343 1 10 1M10 1C7.61305 1 5.32387 1.94821 3.63604 3.63604C1.94821 5.32387 1 7.61305 1 10"
            stroke="#728195"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <Form.Select
        className="w-full"
        name="langSelect"
        onChange={handleChange}
        value={selectedLang}
      >
        <option value="en">EN</option>
        <option value="tr">TR</option>
      </Form.Select>
    </div>
  );
}
export default LanguageSelector;
